import React from 'react';
import { connect } from 'react-redux';
import { AlTemplateTherExRow } from 'PatientCareCenter/Note/AL/Templates';
import styles from './Common.module.css';


class AlTemplateTherEx extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div className={styles.section_wrapper}>
                    <div className={styles.header_row}>Therapeutic Exercises (97110)</div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const result = this.props.activities[key];
                            return (
                                <AlTemplateTherExRow key={result.XLTMPTENO} id={result.XLTMPTENO} />
                            )
                        })
                    }
                </div>
            );
        } else {
            return (<span />);
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        activities: state.entities.notes.MLTMPTHEREX ?
            Object.keys(state.entities.notes.MLTMPTHEREX)
                .filter(key => {
                    return (state.entities.notes.MLTMPTHEREX[key].NoteId === noteId)
                })
                .sort((a, b) => state.entities.notes.MLTMPTHEREX[a].XLTMPTEORDER - state.entities.notes.MLTMPTHEREX[b].XLTMPTEORDER)
                .map(key => state.entities.notes.MLTMPTHEREX[key]) : [],
    };
}

const connectedAlTemplateTherEx = connect(mapStateToProps)(AlTemplateTherEx);
export { connectedAlTemplateTherEx as AlTemplateTherEx };

